module.exports = __webpack_public_path__ + "static/media/orphee1.b17c13d6.JPG";